import { snakeCase } from "lodash";

const envObj = import.meta.env;

const getEnvVar = (key: string): string => {
	const envKey: string = snakeCase(key);

	const viteVariable: string = `VITE_${envKey.toUpperCase()}`;
	const variable: string = envObj?.[viteVariable.toString()] || "";

	return variable;
};

export { envObj, getEnvVar };
